export enum FailureModeDisplayMode {
    Individual = 'individual',
    Total = 'total',
    Both = 'both'
}